import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Mail, Phone } from "lucide-react";
import { api, formatErr } from "@/lib/api";

const STATUSES = [
  { v: "all", label: "Tous" },
  { v: "nouveau", label: "Nouveau" },
  { v: "lu", label: "Lu" },
  { v: "traite", label: "Traité" },
];

export default function AdminContactMessages() {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("all");
  const [expanded, setExpanded] = useState(null);

  const load = () =>
    api.get("/admin/contact-messages", { params: status !== "all" ? { status } : {} })
      .then((r) => setRows(r.data))
      .catch(() => {});

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status]);

  const setRowStatus = async (id, s) => {
    try { await api.patch(`/admin/contact-messages/${id}`, { status: s }); load(); toast.success("Statut mis à jour"); }
    catch (e) { toast.error(formatErr(e)); }
  };

  const remove = async (id) => {
    if (!window.confirm("Supprimer ce message ?")) return;
    try { await api.delete(`/admin/contact-messages/${id}`); load(); toast.success("Supprimé"); }
    catch (e) { toast.error(formatErr(e)); }
  };

  return (
    <div>
      <div className="font-heading text-3xl font-black uppercase tracking-tight">Messages contact</div>
      <div className="h-1 w-16 bg-brand mt-2 mb-6" />

      <div className="flex flex-wrap gap-2 mb-4">
        {STATUSES.map((s) => (
          <button key={s.v} onClick={() => setStatus(s.v)}
            className={`px-3 py-2 text-xs font-bold uppercase tracking-wider border ${status === s.v ? "bg-brand text-white border-brand" : "border-ink-700 text-zinc-400 hover:border-brand"}`}>
            {s.label}
          </button>
        ))}
      </div>

      <div className="grid gap-3">
        {rows.map((r) => (
          <div key={r.id} className="bg-ink-900 border border-ink-700 p-4">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-3 flex-wrap">
                  <div className="font-bold">{r.name}</div>
                  <a href={`mailto:${r.email}`} className="text-zinc-300 hover:text-brand text-sm inline-flex items-center gap-1"><Mail size={12} /> {r.email}</a>
                  {r.phone && <a href={`tel:${r.phone}`} className="text-zinc-300 hover:text-brand text-sm inline-flex items-center gap-1"><Phone size={12} /> {r.phone}</a>}
                  <span className="text-xs text-zinc-500">{(r.created_at || "").slice(0, 16).replace("T", " ")}</span>
                </div>
                <div className={`mt-2 text-sm text-zinc-200 ${expanded === r.id ? "" : "line-clamp-2"}`}>{r.message}</div>
                {r.message?.length > 160 && (
                  <button onClick={() => setExpanded(expanded === r.id ? null : r.id)} className="mt-1 text-xs text-brand">
                    {expanded === r.id ? "Réduire" : "Lire tout"}
                  </button>
                )}
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <select value={r.status || "nouveau"} onChange={(e) => setRowStatus(r.id, e.target.value)} className="bg-ink-800 border border-ink-700 focus:border-brand text-white outline-none px-2 py-1 text-xs">
                  {STATUSES.filter((s) => s.v !== "all").map((s) => <option key={s.v} value={s.v}>{s.label}</option>)}
                </select>
                <button onClick={() => remove(r.id)} className="text-zinc-500 hover:text-red-400"><Trash2 size={14} /></button>
              </div>
            </div>
          </div>
        ))}
        {!rows.length && <div className="text-zinc-500 text-center py-12">Aucun message</div>}
      </div>
    </div>
  );
}
